

export const Gradient = () => {
  return (
    <div className="absolute top-0 -left-[10rem] w-[56.625rem] h-[56.625rem] opacity-50 mix-blend-color-dodge pointer-events-none">
      <img
      className="absolute top-1/4 left-3/4 w-[79.5625rem] max-w-[79.5625rem] h-[88.5625rem] -translate-x-1/2 -translate-y-1/2"
      src={"/assets/gradient.png"}
      width={1417}
      height={1417}
      alt="Gradient"
      />
    </div>
  );
};


